import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";

import { Button } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Tooltip from "components/Inputs/Tooltip";
import numeral from "numeral";

import styles from "./style.module.css";

import * as reportReducer from "containers/Report/ReportReducer";
import * as viewReducer from "containers/View/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as globalReducer from "containers/App/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

const CostSavingsIndicator = ({} = {}) => {
  const allChats = useSelector((state) => viewReducer.getAllChats(state));
  const userName = useSelector((state) => loginReducer.getUserName(state));

  const allChatsWithUsage = allChats?.filter((message) => message?.response_data?.usage !== undefined);
  const allCachedWithUsage = allChatsWithUsage?.filter((chat) => chat?.isCachedResponse);

  const totalCachedSavings = allCachedWithUsage?.reduce((accumulator, message) => {
    const calculatedCost = chatGPTReducer.calcPromptCost(message?.response_data?.usage?.total_tokens, message?.model);
    return accumulator + calculatedCost;
  }, 0);

  const userCachedWithUsage = allCachedWithUsage?.filter((chat) => chat?.analytics?.user === userName);
  const userCachedSavings = userCachedWithUsage?.reduce((accumulator, message) => {
    const calculatedCost = chatGPTReducer.calcPromptCost(message?.response_data?.usage?.total_tokens, message?.model);
    return accumulator + calculatedCost;
  }, 0);

  const otherUserSavings = totalCachedSavings - userCachedSavings;

  const isReportsLoading = useSelector((state) => globalReducer.getIsReportsLoading(state));

  return (
    <Tooltip
      overlay={
        <div className={styles.costSavingsWrapper}>
          <div className={styles.savingsItemWrapper}>
            <div className={styles.savingsText}>{"Other users LLM Savings"}</div>
            <div className={styles.savingsAmount}>{`$${numeral(otherUserSavings).format("0.00[00]")}`}</div>
          </div>
          <div className={styles.savingsItemWrapper}>
            <div className={styles.savingsText}>{"Your LLM Savings"}</div>
            <div className={styles.savingsAmount}>{`$${numeral(userCachedSavings).format("0.00[00]")}`}</div>
          </div>
          <div className={styles.savingsItemWrapper}>
            <div className={styles.savingsFootnote}>
              {"Your savings may be better than reported due to reduced data warehouse query costs."}
            </div>
          </div>
          <div className={styles.savingsFooter}>
            {
              "Aible minimizes LLM costs by showing answers to previously asked questions. These answers are securely stored in your cloud account."
            }
          </div>
        </div>
      }
      placement={"bottom"}
      trigger={[isReportsLoading ? "" : "hover"]}
      rootClose
    >
      <div className={styles.costSavingsButton}>
        <div className={styles.costSavingsButtonAmount}>
          {isReportsLoading ? (
            <LoadingIndicator color={"#FFFFFF"} style={{ margin: "-22px 0px -16px 19px", scale: ".45" }} />
          ) : (
            `$${numeral(totalCachedSavings).format("0.00[00]")}`
          )}
        </div>
        <div className={styles.costSavingsButtonText}>{`LLM CACHING SAVINGS`}</div>
      </div>
    </Tooltip>
  );
};

export default CostSavingsIndicator;
